import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { useContext, isValidElement, createContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { Themes } from '../themes/theme.types.js';
import neutral from '../themes/neutral/index.js';
import index from '../themes/eprisma/index.js';
import index$1 from '../themes/sale/index.js';
import index$2 from '../themes/mestarin-herkku/index.js';
import index$3 from '../themes/sokos-hotels/index.js';
import index$4 from '../themes/sokosfi/index.js';
import index$5 from '../themes/sokos-herkku/index.js';
import index$6 from '../themes/s-market/index.js';
import index$7 from '../themes/prisma/index.js';
import index$8 from '../themes/herkku/index.js';
import index$9 from '../themes/alepa/index.js';
import index$a from '../themes/abc/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DEFAULT_THEME = Themes.NEUTRAL;
/**
 * This method is designed for when you are spreading props down to a native component.
 * For custom properties we do not want to set these on the native element, as they may have
 * unintended consequences.
 *
 * <input {...cleanProps(props, ['myCustomProp'])} />
 */

var cleanProps = function cleanProps(props, propsToRemove) {
  var newProps = _objectSpread({}, props);

  propsToRemove.forEach(function (prop) {
    delete newProps[prop];
  });
  return newProps;
};
var getTheme = function getTheme(theme) {
  switch (theme || DEFAULT_THEME) {
    case Themes.ABC:
      return index$a.components;

    case Themes.ALEPA:
      return index$9.components;

    case Themes.HERKKU:
      return index$8.components;

    case Themes.PRISMA:
      return index$7.components;

    case Themes.SMARKET:
      return index$6.components;

    case Themes.SOKOS_HERKKU:
      return index$5.components;

    case Themes.SOKOSFI:
      return index$4.components;

    case Themes.SOKOS_HOTELS:
      return index$3.components;

    case Themes.MESTARIN_HERKKU:
      return index$2.components;

    case Themes.SALE:
      return index$1.components;

    case Themes.EPRISMA:
      return index.components;

    case Themes.NEUTRAL:
    default:
      return neutral.components;
  }
};
var DesignSystemThemeNameContext = /*#__PURE__*/createContext(DEFAULT_THEME);
var DesignSystemThemeProvider = function DesignSystemThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  var themeName = theme || DEFAULT_THEME;
  return /*#__PURE__*/React__default.createElement(DesignSystemThemeNameContext.Provider, {
    value: themeName
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: getTheme(themeName)
  }, children));
};
var useDesignSystemThemeName = function useDesignSystemThemeName() {
  return useContext(DesignSystemThemeNameContext);
};
/**
 * React Functional Components don't pass ref to children so we need to do this manually in some
 * cases.
 *
 * As a similar example issue -> https://github.com/downshift-js/downshift/issues/1059
 * Used in the Popover component see PopoverWithStyledContent story.
 */

var passRefToChildren = function passRefToChildren(children, ref) {
  return React__default.Children.map(children, function (child) {
    if ( /*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        ref: ref
      });
    }

    return child;
  });
};
var generateId = function generateId(prefix) {
  return Math.random().toString(36).replace('0.', prefix || '');
};

export { DesignSystemThemeProvider, cleanProps, generateId, getTheme, passRefToChildren, useDesignSystemThemeName };
//# sourceMappingURL=utils.js.map
